import { z } from 'zod/mini';
import { listSearchSchema } from '../list/search/list-search-schema';
import type { processDefinitionsArchivedQueryFragment$data } from './__generated__/processDefinitionsArchivedQueryFragment.graphql';

type TProcessDefinitionArchivedKeys =
    keyof processDefinitionsArchivedQueryFragment$data['content'][number];

export const processDefinitionsArchivedSearchSchema = z.intersection(
    listSearchSchema,
    z.object({
        sortBy: z.optional(
            z.catch(
                z.enum<TProcessDefinitionArchivedKeys[]>([
                    // 'createdAt',
                    'definitionKey',
                    'definitionName',
                    'definitionVersion',
                    'listName',
                    'id',
                    // 'status',
                ]),
                'id'
            )
        ),
    })
);

export type TProcessDefinitionsArchivedSearchSchema = z.infer<
    typeof processDefinitionsArchivedSearchSchema
>;
